/** DO NOT EDIT THIS AUTO-GENERATED FILE! */
export const version = '5.4.11';
